import React from 'react';
import SalesCharts from '../components/SalesCharts';

const Dashboard: React.FC = () => {
  return (
    <div className="container-fluid">
      {/* Header del Dashboard */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h2 className="mb-1">
                <i className="fas fa-tachometer-alt me-2 text-primary"></i>
                Dashboard Comercial
              </h2>
              <p className="text-muted mb-0">Análisis de ventas y rendimiento del equipo</p>
            </div>
            <div className="text-end">
              <small className="text-muted">
                Última actualización: {new Date().toLocaleString('es-PE')}
              </small>
            </div>
          </div>
        </div>
      </div>

      {/* Métricas principales */}
      <div className="row g-4 mb-4">
        <div className="col-md-3">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="flex-shrink-0">
                  <div className="bg-primary bg-opacity-10 rounded-circle p-3">
                    <i className="fas fa-target text-primary fs-4"></i>
                  </div>
                </div>
                <div className="flex-grow-1 ms-3">
                  <h6 className="card-title text-muted mb-1">Objetivo Mensual</h6>
                  <h4 className="mb-0 text-primary">90%</h4>
                  <small className="text-success">
                    <i className="fas fa-arrow-up me-1"></i>
                    +5% vs mes anterior
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="flex-shrink-0">
                  <div className="bg-success bg-opacity-10 rounded-circle p-3">
                    <i className="fas fa-chart-line text-success fs-4"></i>
                  </div>
                </div>
                <div className="flex-grow-1 ms-3">
                  <h6 className="card-title text-muted mb-1">Crecimiento</h6>
                  <h4 className="mb-0 text-success">100%</h4>
                  <small className="text-success">
                    <i className="fas fa-arrow-up me-1"></i>
                    +12% vs mes anterior
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="flex-shrink-0">
                  <div className="bg-warning bg-opacity-10 rounded-circle p-3">
                    <i className="fas fa-trophy text-warning fs-4"></i>
                  </div>
                </div>
                <div className="flex-grow-1 ms-3">
                  <h6 className="card-title text-muted mb-1">Superación</h6>
                  <h4 className="mb-0 text-warning">110%</h4>
                  <small className="text-warning">
                    <i className="fas fa-arrow-up me-1"></i>
                    +8% vs mes anterior
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="flex-shrink-0">
                  <div className="bg-info bg-opacity-10 rounded-circle p-3">
                    <i className="fas fa-users text-info fs-4"></i>
                  </div>
                </div>
                <div className="flex-grow-1 ms-3">
                  <h6 className="card-title text-muted mb-1">Vendedores Activos</h6>
                  <h4 className="mb-0 text-info">8</h4>
                  <small className="text-info">
                    <i className="fas fa-check me-1"></i>
                    Todos activos
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Gráficos de ventas */}
      <SalesCharts />
    </div>
  );
};

export default Dashboard;
